var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyJpy = function SvgIconCurrencyJpy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.024 3.867a1 1 0 0 0-1.548 1.266L9.89 11.75H7.5a1 1 0 1 0 0 2H11v1.75H7.5a1 1 0 1 0 0 2H11v2.75a1 1 0 1 0 2 0V17.5h3.5a1 1 0 1 0 0-2H13v-1.75h3.5a1 1 0 1 0 0-2h-2.39l5.414-6.617a1 1 0 0 0-1.548-1.266L12 11.17z"
  })));
};
export default SvgIconCurrencyJpy;